import { resourceLinks } from '@/mocks/home';

export default function ResourceNav() {
  return (
    <section className="py-14 md:py-18 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium mb-3">
            资源导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            韩漫阅读平台入口
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            精选各大主流韩漫平台，免费韩漫大全一网打尽，点击即可直达
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {resourceLinks.map((link) => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="group p-4 md:p-5 bg-background-50 rounded-xl hover:bg-background-200 transition-all duration-200 cursor-pointer border border-background-200"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg mb-3 group-hover:bg-primary-200 transition-colors">
                <i className="ri-external-link-line text-primary-600 text-sm"></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">
                {link.name}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed">
                {link.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}